[
  {
    "id": "suri-001",
    "name": "Suri Design 1",
    "orientation": "landscape",
    "categories": ["General"],
    "tags": ["suri"],
    "artist": "Suri",
    "cardIdLabel": "SURI-001",
    "variants": [
      {
        "id": "suri-001-v1",
        "label": "Default",
        "front": {
          "type": "static",
          "preview": {
            "frontUrl": "/images/suri/design-001.webp",
            "thumbUrl": "/images/suri/design-001.webp"
          },
          "textLayers": [
            {
              "id": "text_1764347495110",
              "label": "New Text",
              "type": "string",
              "defaultValue": "smile",
              "maxLength": 50,
              "bounds": {
                "x": 0.10964285714285714,
                "y": 0.198,
                "width": 0.7821428571428571,
                "height": 0.344
              },
              "fontSize": 0.0229,
              "fontFamily": "Plain, sans-serif",
              "color": "#ffffff",
              "textAlign": "center",
              "fontWeight": "100",
              "defaultFontSize": 0.2850488053613054
            },
            {
              "id": "text_1764347929363",
              "label": "New Text",
              "type": "string",
              "defaultValue": "it's your birthday",
              "maxLength": 50,
              "bounds": {
                "x": 0.12464285714285714,
                "y": 0.763,
                "width": 0.7514285714285714,
                "height": 0.117
              },
              "fontSize": 0.0229,
              "fontFamily": "Plain, sans-serif",
              "color": "#ffff",
              "textAlign": "center",
              "fontWeight": "100",
              "defaultFontSize": 0.0986414627039627
            }
          ]
        },
        "inside": {
          "defaultMessage": "",
          "suggestions": [],
          "maxChars": 600
        }
      }
    ],
    "supportedPaperSizes": ["A5"]
  },
  {
    "id": "suri-002",
    "name": "Suri Design 2",
    "orientation": "landscape",
    "categories": ["General"],
    "tags": ["suri"],
    "artist": "Suri",
    "cardIdLabel": "SURI-002",
    "variants": [
      {
        "id": "suri-002-v1",
        "label": "Default",
        "front": {
          "type": "static",
          "preview": {
            "frontUrl": "/images/suri/design-002.webp",
            "thumbUrl": "/images/suri/design-002.webp"
          },
          "textLayers": [
            {
              "id": "text_suri002_1",
              "label": "New Text",
              "type": "string",
              "defaultValue": "Welcome to the clean of a lifetime.",
              "maxLength": 50,
              "bounds": {
                "x": 0.4357142857142857,
                "y": 0.384,
                "width": 0.45571428571428574,
                "height": 0.223
              },
              "fontSize": 0.0229,
              "fontFamily": "Plain, sans-serif",
              "color": "#ffffff",
              "textAlign": "right",
              "fontWeight": "200",
              "defaultFontSize": 0.07767063665501167
            }
          ]
        },
        "inside": {
          "defaultMessage": "",
          "suggestions": [],
          "maxChars": 600
        }
      }
    ],
    "supportedPaperSizes": ["A5"]
  },
  {
    "id": "suri-003",
    "name": "Suri Design 3",
    "orientation": "landscape",
    "categories": ["General"],
    "tags": ["suri"],
    "artist": "Suri",
    "cardIdLabel": "SURI-003",
    "variants": [
      {
        "id": "suri-003-v1",
        "label": "Default",
        "front": {
          "type": "static",
          "preview": {
            "frontUrl": "/images/suri/design-003.webp",
            "thumbUrl": "/images/suri/design-003.webp"
          },
          "textLayers": [
            {
              "id": "text_suri003_1",
              "label": "New Text",
              "type": "string",
              "defaultValue": "Welcome to the clean of a lifetime.",
              "maxLength": 50,
              "bounds": {
                "x": 0.12785714285714286,
                "y": 0.377,
                "width": 0.45571428571428574,
                "height": 0.223
              },
              "fontSize": 0.0229,
              "fontFamily": "Plain, sans-serif",
              "color": "#ffffff",
              "textAlign": "left",
              "fontWeight": "200",
              "defaultFontSize": 0.07767063665501167
            }
          ]
        },
        "inside": {
          "defaultMessage": "",
          "suggestions": [],
          "maxChars": 600
        }
      }
    ],
    "supportedPaperSizes": ["A5"]
  },
  {
    "id": "suri-004",
    "name": "Suri Design 4",
    "orientation": "landscape",
    "categories": ["General"],
    "tags": ["suri"],
    "artist": "Suri",
    "cardIdLabel": "SURI-004",
    "variants": [
      {
        "id": "suri-004-v1",
        "label": "Default",
        "front": {
          "type": "static",
          "preview": {
            "frontUrl": "/images/suri/design-004.webp",
            "thumbUrl": "/images/suri/design-004.webp"
          },
          "textLayers": [
            {
              "id": "text_1764355801461",
              "label": "New Text",
              "type": "string",
              "defaultValue": "Congratulations",
              "maxLength": 50,
              "bounds": {
                "x": 0.2692857142857143,
                "y": 0.105,
                "width": 0.4614285714285714,
                "height": 0.16
              },
              "fontSize": 0.0229,
              "fontFamily": "Plain, sans-serif",
              "color": "#252525",
              "textAlign": "center",
              "fontWeight": "100",
              "defaultFontSize": 0.0916511873543124
            }
          ]
        },
        "inside": {
          "defaultMessage": "",
          "suggestions": [],
          "maxChars": 600
        }
      }
    ],
    "supportedPaperSizes": ["A5"]
  },
  {
    "id": "suri-005",
    "name": "Suri Design 5",
    "orientation": "landscape",
    "categories": ["General"],
    "tags": ["suri"],
    "artist": "Suri",
    "cardIdLabel": "SURI-005",
    "variants": [
      {
        "id": "suri-005-v1",
        "label": "Default",
        "front": {
          "type": "static",
          "preview": {
            "frontUrl": "/images/suri/design-005.webp",
            "thumbUrl": "/images/suri/design-005.webp"
          },
          "textLayers": [
            {
              "id": "text_1764348006512",
              "label": "New Text",
              "type": "string",
              "defaultValue": "Welcome to the clean of a lifetime.",
              "maxLength": 50,
              "bounds": {
                "x": 0.1,
                "y": 0.39,
                "width": 0.45571428571428574,
                "height": 0.223
              },
              "fontSize": 0.0229,
              "fontFamily": "Plain, sans-serif",
              "color": "#252525",
              "textAlign": "left",
              "fontWeight": "200",
              "defaultFontSize": 0.07767063665501167
            }
          ]
        },
        "inside": {
          "defaultMessage": "",
          "suggestions": [],
          "maxChars": 600
        }
      }
    ],
    "supportedPaperSizes": ["A5"]
  },
  {
    "id": "suri-006",
    "name": "Suri Design 6",
    "orientation": "landscape",
    "categories": ["General"],
    "tags": ["suri"],
    "artist": "Suri",
    "cardIdLabel": "SURI-006",
    "variants": [
      {
        "id": "suri-006-v1",
        "label": "Default",
        "front": {
          "type": "static",
          "preview": {
            "frontUrl": "/images/suri/design-006.webp",
            "thumbUrl": "/images/suri/design-006.webp"
          },
          "textLayers": [
            {
              "id": "text_suri006_1",
              "label": "New Text",
              "type": "string",
              "defaultValue": "Welcome to the clean of a lifetime.",
              "maxLength": 50,
              "bounds": {
                "x": 0.1,
                "y": 0.39,
                "width": 0.45571428571428574,
                "height": 0.223
              },
              "fontSize": 0.0229,
              "fontFamily": "Plain, sans-serif",
              "color": "#252525",
              "textAlign": "left",
              "fontWeight": "200",
              "defaultFontSize": 0.07767063665501167
            }
          ]
        },
        "inside": {
          "defaultMessage": "",
          "suggestions": [],
          "maxChars": 600
        }
      }
    ],
    "supportedPaperSizes": ["A5"]
  },
  {
    "id": "suri-007",
    "name": "Suri Design 7",
    "orientation": "landscape",
    "categories": ["General"],
    "tags": ["suri"],
    "artist": "Suri",
    "cardIdLabel": "SURI-007",
    "variants": [
      {
        "id": "suri-007-v1",
        "label": "Default",
        "front": {
          "type": "static",
          "preview": {
            "frontUrl": "/images/suri/design-007.webp",
            "thumbUrl": "/images/suri/design-007.webp"
          },
          "textLayers": [
            {
              "id": "text_suri007_1",
              "label": "New Text",
              "type": "string",
              "defaultValue": "Welcome to the clean of a lifetime.",
              "maxLength": 50,
              "bounds": {
                "x": 0.1,
                "y": 0.39,
                "width": 0.45571428571428574,
                "height": 0.223
              },
              "fontSize": 0.0229,
              "fontFamily": "Plain, sans-serif",
              "color": "#252525",
              "textAlign": "left",
              "fontWeight": "200",
              "defaultFontSize": 0.07767063665501167
            }
          ]
        },
        "inside": {
          "defaultMessage": "",
          "suggestions": [],
          "maxChars": 600
        }
      }
    ],
    "supportedPaperSizes": ["A5"]
  },
  {
    "id": "suri-008",
    "name": "Suri Design 8",
    "orientation": "landscape",
    "categories": ["General"],
    "tags": ["suri"],
    "artist": "Suri",
    "cardIdLabel": "SURI-008",
    "variants": [
      {
        "id": "suri-008-v1",
        "label": "Default",
        "front": {
          "type": "static",
          "preview": {
            "frontUrl": "/images/suri/design-008.webp",
            "thumbUrl": "/images/suri/design-008.webp"
          },
          "textLayers": [
            {
              "id": "text_suri008_1",
              "label": "New Text",
              "type": "string",
              "defaultValue": "Welcome to the clean of a lifetime.",
              "maxLength": 50,
              "bounds": {
                "x": 0.1,
                "y": 0.39,
                "width": 0.45571428571428574,
                "height": 0.223
              },
              "fontSize": 0.0229,
              "fontFamily": "Plain, sans-serif",
              "color": "#252525",
              "textAlign": "left",
              "fontWeight": "200",
              "defaultFontSize": 0.07767063665501167
            }
          ]
        },
        "inside": {
          "defaultMessage": "",
          "suggestions": [],
          "maxChars": 600
        }
      }
    ],
    "supportedPaperSizes": ["A5"]
  },
  {
    "id": "suri-009",
    "name": "Suri Design 9",
    "orientation": "landscape",
    "categories": ["General"],
    "tags": ["suri"],
    "artist": "Suri",
    "cardIdLabel": "SURI-009",
    "variants": [
      {
        "id": "suri-009-v1",
        "label": "Default",
        "front": {
          "type": "static",
          "preview": {
            "frontUrl": "/images/suri/design-009.webp",
            "thumbUrl": "/images/suri/design-009.webp"
          },
          "textLayers": [
            {
              "id": "text_suri009_1",
              "label": "New Text",
              "type": "string",
              "defaultValue": "Welcome to the clean of a lifetime.",
              "maxLength": 50,
              "bounds": {
                "x": 0.1,
                "y": 0.39,
                "width": 0.45571428571428574,
                "height": 0.223
              },
              "fontSize": 0.0229,
              "fontFamily": "Plain, sans-serif",
              "color": "#252525",
              "textAlign": "left",
              "fontWeight": "200",
              "defaultFontSize": 0.07767063665501167
            }
          ]
        },
        "inside": {
          "defaultMessage": "",
          "suggestions": [],
          "maxChars": 600
        }
      }
    ],
    "supportedPaperSizes": ["A5"]
  },
  {
    "id": "suri-010",
    "name": "Suri Design 10",
    "orientation": "landscape",
    "categories": ["General"],
    "tags": ["suri"],
    "artist": "Suri",
    "cardIdLabel": "SURI-010",
    "variants": [
      {
        "id": "suri-010-v1",
        "label": "Default",
        "front": {
          "type": "static",
          "preview": {
            "frontUrl": "/images/suri/design-010.webp",
            "thumbUrl": "/images/suri/design-010.webp"
          },
          "textLayers": [
            {
              "id": "text_suri010_1",
              "label": "New Text",
              "type": "string",
              "defaultValue": "Welcome to the clean of a lifetime.",
              "maxLength": 50,
              "bounds": {
                "x": 0.1,
                "y": 0.39,
                "width": 0.45571428571428574,
                "height": 0.223
              },
              "fontSize": 0.0229,
              "fontFamily": "Plain, sans-serif",
              "color": "#252525",
              "textAlign": "left",
              "fontWeight": "200",
              "defaultFontSize": 0.07767063665501167
            }
          ]
        },
        "inside": {
          "defaultMessage": "",
          "suggestions": [],
          "maxChars": 600
        }
      }
    ],
    "supportedPaperSizes": ["A5"]
  },
  {
    "id": "suri-011",
    "name": "Suri Design 11",
    "orientation": "landscape",
    "categories": ["General"],
    "tags": ["suri"],
    "artist": "Suri",
    "cardIdLabel": "SURI-011",
    "variants": [
      {
        "id": "suri-011-v1",
        "label": "Default",
        "front": {
          "type": "static",
          "preview": {
            "frontUrl": "/images/suri/design-011.webp",
            "thumbUrl": "/images/suri/design-011.webp"
          },
          "textLayers": [
            {
              "id": "text_suri011_1",
              "label": "New Text",
              "type": "string",
              "defaultValue": "Welcome to the clean of a lifetime.",
              "maxLength": 50,
              "bounds": {
                "x": 0.1,
                "y": 0.39,
                "width": 0.45571428571428574,
                "height": 0.223
              },
              "fontSize": 0.0229,
              "fontFamily": "Plain, sans-serif",
              "color": "#252525",
              "textAlign": "left",
              "fontWeight": "200",
              "defaultFontSize": 0.07767063665501167
            }
          ]
        },
        "inside": {
          "defaultMessage": "",
          "suggestions": [],
          "maxChars": 600
        }
      }
    ],
    "supportedPaperSizes": ["A5"]
  },
  {
    "id": "suri-012",
    "name": "Suri Design 12",
    "orientation": "landscape",
    "categories": ["General"],
    "tags": ["suri"],
    "artist": "Suri",
    "cardIdLabel": "SURI-012",
    "variants": [
      {
        "id": "suri-012-v1",
        "label": "Default",
        "front": {
          "type": "static",
          "preview": {
            "frontUrl": "/images/suri/design-012.webp",
            "thumbUrl": "/images/suri/design-012.webp"
          },
          "textLayers": [
            {
              "id": "text_suri012_1",
              "label": "New Text",
              "type": "string",
              "defaultValue": "Welcome to the clean of a lifetime.",
              "maxLength": 50,
              "bounds": {
                "x": 0.1,
                "y": 0.39,
                "width": 0.45571428571428574,
                "height": 0.223
              },
              "fontSize": 0.0229,
              "fontFamily": "Plain, sans-serif",
              "color": "#252525",
              "textAlign": "left",
              "fontWeight": "200",
              "defaultFontSize": 0.07767063665501167
            }
          ]
        },
        "inside": {
          "defaultMessage": "",
          "suggestions": [],
          "maxChars": 600
        }
      }
    ],
    "supportedPaperSizes": ["A5"]
  }
]
